export default __webpack_public_path__ + "static/media/entidades_compradoras.cead40e2.svg";